import { render, staticRenderFns } from "./Armour.vue?vue&type=template&id=483039ba&"
import script from "./Armour.vue?vue&type=script&lang=js&"
export * from "./Armour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports